module.exports = __webpack_public_path__ + "static/media/football_pitch.34054bf6.svg";